import React from "react";
import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";
import Router from "./router";
// import ApiProvider from "./store/contextProvider";
import { UserProvider } from "./store/UserLoginContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <UserProvider>
      <Router />
    </UserProvider>
  </React.StrictMode>
  // <React.StrictMode>
  //   {/* <BrowserRouter> */}
  //   <ApiProvider>
  //     <Router />
  //   </ApiProvider>
  //   {/* </BrowserRouter> */}
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
